const toStringOrNull = (value) => {
  if (value == null) return null;
  const normalized = String(value).trim();
  return normalized || null;
};

export const bytesToBase64 = (bytes) => {
  if (!(bytes instanceof Uint8Array) || bytes.length === 0) {
    return '';
  }
  if (typeof Buffer !== 'undefined') {
    return Buffer.from(bytes).toString('base64');
  }
  let binary = '';
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary);
};

export const base64ToBytes = (value) => {
  const normalized = toStringOrNull(value);
  if (!normalized) {
    return new Uint8Array();
  }
  if (typeof Buffer !== 'undefined') {
    return new Uint8Array(Buffer.from(normalized, 'base64'));
  }
  const binary = atob(normalized);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }
  return bytes;
};

export const decodeBase64ToUtf8 = (value) => {
  const bytes = base64ToBytes(value);
  if (!(bytes instanceof Uint8Array) || bytes.length === 0) {
    return null;
  }
  if (typeof TextDecoder !== 'undefined') {
    return new TextDecoder().decode(bytes);
  }
  if (typeof Buffer !== 'undefined') {
    return Buffer.from(bytes).toString('utf8');
  }
  return null;
};

export const utf8ToUint8Array = (value) => {
  const normalized = toStringOrNull(value);
  if (!normalized) {
    return new Uint8Array();
  }
  if (typeof TextEncoder !== 'undefined') {
    return new TextEncoder().encode(normalized);
  }
  if (typeof Buffer !== 'undefined') {
    return new Uint8Array(Buffer.from(normalized, 'utf8'));
  }
  const bytes = new Uint8Array(normalized.length);
  for (let index = 0; index < normalized.length; index += 1) {
    bytes[index] = normalized.charCodeAt(index) & 0xff;
  }
  return bytes;
};

export const randomUuid = () => {
  const cryptoApi =
    (typeof globalThis !== 'undefined' && globalThis.crypto) ||
    (typeof window !== 'undefined' ? window.crypto : null);
  if (cryptoApi?.randomUUID) {
    return cryptoApi.randomUUID();
  }
  return `uuid-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export const normalizeSuiteId = (value) => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }
  const normalized = String(value ?? '').trim();
  if (!normalized) {
    return null;
  }
  if (/^0x[0-9a-f]+$/i.test(normalized)) {
    const parsedHex = Number.parseInt(normalized, 16);
    return Number.isFinite(parsedHex) ? parsedHex : null;
  }
  if (/^\d+$/.test(normalized)) {
    const parsedDecimal = Number.parseInt(normalized, 10);
    return Number.isFinite(parsedDecimal) ? parsedDecimal : null;
  }
  if (/^[0-9a-f]+$/i.test(normalized)) {
    const parsedHex = Number.parseInt(normalized, 16);
    return Number.isFinite(parsedHex) ? parsedHex : null;
  }
  return null;
};
export const compareMessengerV2RailItems = (left, right) => {
  const pinDelta = String(right.pinnedAt || '').localeCompare(String(left.pinnedAt || ''));
  if (pinDelta) return pinDelta;
  const timeDelta = (right.sortTime || 0) - (left.sortTime || 0);
  if (timeDelta) return timeDelta;
  return String(left.title || '').localeCompare(String(right.title || ''), undefined, {
    sensitivity: 'base',
  });
};
